import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { EuiButtonIcon, EuiPopover, EuiRange } from "@elastic/eui";
import { setViewState, setRadius } from "ducks/ui/entriesMap";

const Options = () => {
  const mapState = useSelector(state => state.entriesMap);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  console.log(mapState);
  return (
    <div>
      <EuiButtonIcon
        onClick={() =>
          dispatch(
            setViewState({
              ...mapState.viewState,
              longitude: mapState.picked.coordinates[0],
              latitude: mapState.picked.coordinates[1],
              zoom: 15
            })
          )
        }
        iconType="crosshairs"
      />
      <EuiPopover
        button={
          <EuiButtonIcon
            iconType="expand"
            onClick={() => setOpen(!open)}
          ></EuiButtonIcon>
        }
        isOpen={open}
        closePopover={() => setOpen(false)}
      >
        <div style={{ width: "300px" }}>
          <EuiRange
            showInput
            min={0}
            max={1000}
            step={10}
            value={mapState.radius}
            onChange={e => dispatch(setRadius(parseInt(e.target.value, 10)))}
            showLabels
            showValue
            aria-label="An example of EuiRange with showValue prop"
          />
        </div>
      </EuiPopover>
    </div>
  );
};
export default Options;
